<template lang="pug">
  div
    HeaderCentral(
      :imageLogoSrc="require('@/assets/images/logo.png')"
      descricaoLogo="Sistema de Cadastro e Regularização Fundiária"
    )
      template(slot="RightButtons")
        ProfileButton(
          :nameUser="getNomeUsuario"
          :namePerfil="getPerfil"
          :emailUser="`${usuario.pessoa.email}`"
          :opcoesProfileButton="[{ text: 'Módulos', action: () => irParaSelecaoModulos() }]"
          :ButtonSair="{ text: 'Sair', action: () => sair() }"
        )
    main.container.text-center
      el-row.container(
        type="flex",
        justify="center",
        :gutter="20"
      )
        p.text-center Clique sobre o botão correspondente ao perfil que deseja acessar o sistema:
      el-row.container(
        type="flex",
        justify="center",
        :gutter="20",
        v-if="usuario"
      )
        el-col(:xs="24", :sm="12", :md="8", :lg="6", :xl="4",
                v-for ="perfil in [...perfis].sort((a, b) => (a.nome > b.nome) ? 1 : -1)",
                :key="perfil.id"
              )
          .card(@click="setPerfilUsuario(perfil)")
            el-card
              div(slot="header")
                img.perfil(:src="imgPerfil(perfil)")
              div
                span {{ perfil.nome }}
      el-button.button(type="default" @click="irParaSelecaoModulos")
        span.center
          i.fas.fa-chevron-left
          span &nbsp Voltar
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import HeaderCentral from '@/components(new)/layout/Headers/HeaderCentral/HeaderCentral.vue'
import ProfileButton from '@/components(new)/UI/Buttons/ProfileButton/ProfileButton.vue'

export default {
  components: {
    HeaderCentral,
    ProfileButton
  },

  computed: {
    ...mapGetters({
      usuario: 'auth/usuarioLogado'
    }),
    getNomeUsuario () {
      if (!this.usuario) return
      return this.usuario.pessoa.nomeRazaoSocial
    },
    getPerfil () {
      if (!this.usuario) return
      return this.usuario.perfilSelecionado ? this.usuario.perfilSelecionado.nome : null
    }
  },

  data () {
    return {
      perfis: []
    }
  },

  async created () {
    this.perfis = await this.findPerfisUsuario({ idUsuario: this.usuario.id, idModulo: this.usuario.moduloSelecionado.id })
  },

  methods: {
    ...mapActions({
      getToken: 'auth/getToken',
      selecionePerfil: 'auth/selecionePerfil',
      findPerfisUsuario: 'usuario/findPerfisUsuario'
    }),

    async setPerfilUsuario (perfil) {
      await this.selecionePerfil({ moduloId: this.usuario.moduloSelecionado.id, perfilId: perfil.id })
      this.$router.push({
        name: this.usuario.perfilSelecionado.paginaInicial
      })
    },

    irParaSelecaoModulos () {
      this.$router.push({ name: 'selecionarModulo' })
    },

    async sair () {
      this.$router.push({ name: 'logout' })
    },

    imgPerfil (perfil) {
      return 'static/perfis/' + perfil.icone
    }
  }
}
</script>

<style lang="scss" scoped>

  .text-center {
    text-align: center;
  }

  .button {
    margin: 20px;
  }

  .container {
    width: 100%;
    padding: 20px;
    display: flex;
    flex-wrap: wrap;
    * {
      flex-wrap: wrap;
    }
  }

  .card {
    margin-bottom: 10px;
    flex-wrap: wrap;
    cursor: pointer;
    > :hover{
      transform: scale(1.05);
      transition-property: 2s;
    }
  }

  .perfil {
    width: 180px;
    height: 180px;
  }

  @media (max-width: 780px) {

  .back {
    background-color: aqua;
  }

}
</style>



// WEBPACK FOOTER //
// src/screens/portal/seguranca/SelecionarPerfil.vue